var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('sample-header'),(!_vm.loaded)?_c('loading-indicator',{attrs:{"message":"Please wait"}}):_vm._e(),(_vm.loaded)?_c('div',[_c('router-view')],1):_vm._e(),_c('sample-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }